// components/CustomerProducts.jsx - Customer Products Container
import React from 'react';
import CustomerProductCard from './CustomerProductCard';

const CustomerProducts = ({ displayProducts, user, gold, translate, onDelete, deleteThisProductId }) => {
  console.log({ displayProducts });
  return (
    <div className='customer-products-container'>
      {displayProducts.map((product, index) => (
        <CustomerProductCard
          key={product['customers_basket_id']}
          product={product}
          index={index}
          user={user}
          gold={gold}
          translate={translate}
          onDelete={onDelete}
          deleteThisProductId={deleteThisProductId}
        />
      ))}
    </div>
  );
};

export default CustomerProducts;
